import { Component, output, ChangeDetectionStrategy } from "@angular/core";
import { SelectionModel } from "@angular/cdk/collections";
import { AppService } from "../../../app.service";
import { AuctionType } from "../../../models/auctionType";

@Component({
  standalone: false,
  selector: 'app-auction-type-filter',
  templateUrl: './auction-type-filter.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./auction-type-filter.component.scss']
})
export class AuctionTypeFilterComponent {
  readonly onAuctionTypeSelectionChange = output<AuctionType[] | undefined>();

  public auctionTypes: AuctionType[];

  /** Checkbox state while the menu is open (not yet applied). */
  public auctionTypeSelection = new SelectionModel<number>(true, []);

  /** Last applied selection — what menuLabel/allTypesSelected reflect, and what we revert to on outside-click close. */
  private committedAuctionTypeIds: number[] = [];

  constructor(private appService: AppService) {
    // currently we do not show make offer / buy now
    this.auctionTypes = this.appService.auctionTypes.filter(at => at.id != 2);
  }

  public presetSelectedAuctionTypes(atArray: AuctionType[] | undefined) {
    const ids = (atArray ?? []).map(at => at.id);
    this.committedAuctionTypeIds = [...ids];
    this.auctionTypeSelection = new SelectionModel<number>(true, ids);
  }

  get allTypesSelected(): boolean {
    return this.committedAuctionTypeIds.length === 0;
  }

  get menuLabel(): string {
    if (this.allTypesSelected) return "All Listings";
    const selected = this.auctionTypes.filter(at => this.committedAuctionTypeIds.includes(at.id));
    if (!selected.length) return "All Listings";
    const [first, ...rest] = selected;
    return first.name + (rest.length > 0 ? ` (+${rest.length})` : "");
  }

  public isAuctionTypeChecked(at: AuctionType): boolean {
    return this.auctionTypeSelection.isSelected(at.id);
  }

  public toggleAllTypes(checked: boolean) {
    if (checked) this.auctionTypeSelection.clear();
  }

  public toggleAuctionType(at: AuctionType) {
    this.auctionTypeSelection.toggle(at.id);
  }

  /** Fires with the reason the menu closed: falsy = dismissed via outside click -> discard staged changes. */
  public onMenuClosed(reason: any) {
    if (!reason) {
      this.auctionTypeSelection = new SelectionModel<number>(true, this.committedAuctionTypeIds);
    }
  }

  public onApplyClick() {
    this.committedAuctionTypeIds = [...this.auctionTypeSelection.selected];
    this.emitSelection();
  }

  public onClearClick() {
    this.auctionTypeSelection.clear();
    this.committedAuctionTypeIds = [];
    this.emitSelection();
  }

  private emitSelection() {
    if (this.allTypesSelected) {
      this.onAuctionTypeSelectionChange.emit(undefined);
      return;
    }

    const atArray = this.auctionTypes.filter(at => this.auctionTypeSelection.isSelected(at.id));
    this.onAuctionTypeSelectionChange.emit(atArray);
  }
}